import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import {useMemo} from 'react'

import usePermissionCanEditProject from '../../../hooks/usePermissionCanEditProject'

import {editPermissionDenyMessage} from './PipelineEditButton.consts'

function usePipelineEditButton() {
  const hasEditPermission = usePermissionCanEditProject()
  const permissionDenyMessage = !hasEditPermission ? editPermissionDenyMessage : undefined
  const popupProps = useMemo(
    () => ({
      offset: 10,
      autoPositioning: true,
      autoCorrectTopOverflow: true,
      directions: [Directions.TOP_CENTER],
    }),
    [],
  )

  return {
    popupProps,
    hasEditPermission,
    permissionDenyMessage,
  }
}

export default usePipelineEditButton
